import { getRoutes } from './routes';
import { default as state } from './state';

export const config = function(store) {
    return {routes: getRoutes(store), state};
};